export default __webpack_public_path__ + "static/media/api.462e1963.svg";